import * as React from 'react';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';
import Titulo from '../../Titulo';
import GradeHistoricoRecente from '../../Historico/Grade';

export default function HistoricoRecente() {
    const navigate = useNavigate();

    return (
        <>
            <Titulo>Histórico Recente</Titulo>
            <GradeHistoricoRecente
                sizeTable="small"
                limit={5} />
            <Link 
                color="primary" 
                component="button"
                variant="body2"
                onClick={() => navigate('/historicos')} 
                sx={{ mt: 3, alignSelf: 'flex-start' }}
            >
                Mais Históricos
            </Link>
        </>
    );
}